<template>
  <div :id="inputDivId" class="bubble-tile comp-start">
    <div class="select-card-ques">
      {{ info.message }}
    </div>

    <div
      v-for="(item, itemIndex) in list"
      :key="itemIndex"
      class="col-md-4 col-xs-12 select-tile select-band"
      :class="[
        item.isSelected ? 'selected-tile' : '',
        isTouchDevice ? '' : item.isSelected ? '' : 'hoverClass',
      ]"
      @click="onSelectItem(itemIndex)"
    >
      <div class="tile-data">
        {{ item.staffRange }}
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop } from "vue-facing-decorator";
import { Vue } from "vue-facing-decorator";
import _ from "underscore";
import Utils from "@/utils/utilities";

@Component({})
export default class BubbleSelect extends Vue {
  public list: any = [];
  public selectedList: any = [];
  public selectedClass: any;
  public isTouchDevice = false;
  public inputDivId = "";

  @Prop()
  public info!: any;

  @Prop()
  public isSingleSelect!: boolean;

  async mounted() {
    this.inputDivId = "bubble-tile-" + this.info.id;
    let lowerRange: any;
    let upperRange: any;
    this.setIsDeviceHasTouch();
    if (this.info && this.info.type_values) {
      let listKeyInJSON = await Utils.getQuestionsMatchedListKey(this.info.id);

      if (
        listKeyInJSON &&
        this.info.type_values[listKeyInJSON] &&
        this.info.type_values[listKeyInJSON].length > 0
      ) {
        this.list = this.info.type_values[listKeyInJSON];
        this.list = _.sortBy(this.list, "order");
      }

      if (this.info.values && this.info.values.length > 0) {
        if (this.isSingleSelect) {
          const iRecIndex = this.list.findIndex(
            (r: any) => r.id === this.info.values[0],
          );
          if (iRecIndex >= 0) {
            this.list[iRecIndex].isSelected = true;
          }
        } else {
          for (let i = 0; i < this.info.values.length; i++) {
            const iRecIndex = this.list.findIndex(
              (r: any) => r.id === this.info.values[i],
            );
            if (iRecIndex >= 0) {
              this.list[iRecIndex].isSelected = true;
            }
          }
        }
      }

      for (let i = 0; i < this.list.length; i++) {
        if (i != this.list.length - 1) {
          lowerRange = this.list[i].from;
          upperRange = this.list[i + 1].from - 1;

          this.list[i].staffRange = lowerRange + " - " + upperRange;
        } else {
          this.list[i].staffRange = ">= " + this.list[i].from;
        }
      }
    }
  }

  onSelectItem(itemIndex: number) {
    if (itemIndex >= 0) {
      let dupList: any = [].concat(this.list);

      if (this.isSingleSelect) {
        const iRecIndex = this.list.findIndex(
          (r: any) => r.isSelected === true,
        );

        if (iRecIndex >= 0) {
          dupList[iRecIndex].isSelected = false;
        }
        if (iRecIndex !== itemIndex) {
          dupList[itemIndex].isSelected = dupList[itemIndex].isSelected
            ? false
            : true;
        }
      } else {
        dupList[itemIndex].isSelected = dupList[itemIndex].isSelected
          ? false
          : true;
      }
      this.list = [].concat(dupList);
    }
  }

  setIsDeviceHasTouch() {
    this.isTouchDevice = false;
    const isTouchable =
      "ontouchstart" in window || navigator.maxTouchPoints > 0;
    if (
      !isTouchable &&
      /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
        navigator.userAgent.toLowerCase(),
      )
    ) {
      this.isTouchDevice = true;
    } else {
      this.isTouchDevice = isTouchable ? true : false;
    }
  }
  beforeUnmount() {
    this.list = [];
    this.selectedList = [];
  }
}
</script>
<style lang="scss" scoped>
.bubble-tile {
  display: table;
}

.select-card-ques {
  color: #231f20;
  font-size: 26px;
  margin-bottom: 39px;
}
.select-tile {
  border: 3px solid #ffffff;
  box-sizing: content-box;
  box-shadow: 0px 0px 10px rgba(183, 183, 183, 0.4);
  border-radius: 6px;
  padding: 15px 10px 10px;
  text-align: center;
  background: #ffffff;
  margin-right: 15px;
  margin-left: 15px;
  max-width: 21%;
  color: #0345bd;
  font-size: 20px;
  height: 45px;
  display: flex;
  margin-top: 20px;
  margin-bottom: 20px;
  float: left;
  align-items: center;
}
.select-tile .show-icon {
  display: none;
}

.selected-tile {
  background: #0345bd;
  box-shadow: 0px 0px 10px rgba(183, 183, 183, 0.4);
  border-radius: 6px;
  color: white;
  padding: 24px 20.5px 22px;
  max-width: 21%;
  margin-right: 7.5px;
  margin-left: 7.5px;
  margin-bottom: 12px;
  margin-top: 13px;
  text-align: center;
  border: none;
}
.selected-tile .show-icon {
  display: block;
  position: absolute;
  right: 2%;
  top: 0%;
}
.select-band {
  border-radius: 200px;
}
.hoverClass:hover {
  border: 3px solid #0345bd;
}

.selected-band {
  border: 3px solid #0345bd;
}

.tile-data {
  width: 100%;
  text-align: center;
}

@media (max-width: 360px) {
  .select-tile {
    max-width: 100%;
    margin-left: 5px;
    margin-right: 15px;
    padding: 15px 10px 10px;
    margin-top: 20px;
    margin-bottom: 20px;

    font-size: 18px;
  }
  .selected-tile {
    border: 3px solid #0345bd;
    margin-left: 1px;
    margin-right: 15px;
    padding: 20px 15px 20px;
    margin-top: 12px;
    margin-bottom: 13px;
  }
}

@media (min-width: 361px) and (max-width: 767px) {
  .select-tile {
    font-size: 18px;
    max-width: 90%;
    margin-left: 14px;
    padding: 15px 10px 15px;
    margin-right: 15px;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .selected-tile {
    border: 3px solid #0345bd;
    margin-left: 1px;
    padding: 25px 20px 25px;
    margin-right: 15px;
    margin-top: 10px;
    margin-bottom: 10px;
  }
}
@media (min-width: 768px) and (max-width: 1023px) {
  .select-tile {
    margin-right: 20px;
    margin-left: 20px;
    max-width: 35%;
    height: 55px;
    padding: 15px 10px 10px;
  }
  .selected-tile {
    padding: 27px 25px 18px;
    margin-left: 10px;
    margin-right: 6px;
    margin-top: 11px;
    margin-bottom: 15px;
  }
}
@media (min-width: 769px) and (max-width: 812px) and (orientation: landscape) {
  .select-tile {
    max-width: 36%;
    padding: 13px 10px 10px 10px;
    margin-left: 11px;
    margin-right: 10px;
    margin-top: 8px;
    margin-bottom: 8px;
    font-size: 18px;
    height: 50px;
  }
  .selected-tile {
    padding: 19px 18px 20px 18px;
    margin-top: 2px;
    margin-right: 6px;
    margin-bottom: 4px;
    margin-left: 5px;
  }
}

@media (min-width: 1025px) and (max-width: 1280px) and (orientation: landscape) {
  .select-tile {
    max-width: 24%;
    padding: 18px 9px 10px;
    margin-right: 10px;
    margin-left: 10px;
  }
  .selected-tile {
    padding: 30px 20px 19px;
    margin-top: 10px;
    margin-right: 2px;
    margin-left: 2px;
    margin-bottom: 15px;
  }
}

@media (max-width: 1024px) and (min-width: 813px) and (orientation: landscape) {
  .select-tile {
    max-width: 40%;
    padding: 24px 5px 12px;
    margin-top: 20px;
    margin-bottom: 20px;
    margin-right: 10px;
    margin-left: 10px;
  }
  .selected-tile {
    padding: 32px 15px 26px;
    margin-bottom: 14px;
    margin-top: 10px;
    margin-right: 3px;
    margin-left: 3px;
  }
}
@media (min-width: 3840px) {
  .select-tile {
    height: 100px;
    margin-right: 30px;
    margin-left: 30px;
    margin-top: 30px;
    margin-bottom: 30px;
    max-width: 25%;
    padding: 33px 15px 25px;
    font-size: 36px;
  }
  .selected-tile {
    padding: 53px 35px 36px;
    margin-right: 12px;
    margin-left: 14px;
    margin-top: 13px;
    margin-bottom: 22px;
    max-width: 25%;
  }
}
</style>
